import { Controller } from "@hotwired/stimulus"

// Keeps the selected-value echo in an option group's header in sync when a
// swatch or the ring-size select is changed. Server-side re-renders (set_ui
// turbo streams) remain the source of truth and overwrite this optimistic
// update.
export default class extends Controller {
  static targets = ["echo"]

  sync(event) {
    if (!this.hasEchoTarget) return

    const label =
      event.target.dataset.swatchLabel ?? event.target.selectedOptions?.[0]?.text.trim()

    if (label) this.echoTarget.textContent = label
  }
}
